import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withModifiers as _withModifiers, mergeProps as _mergeProps, withKeys as _withKeys } from "vue";
const _hoisted_1 = { class: "sidebar-header" };
const _hoisted_2 = ["src"];
const _hoisted_3 = {
    key: 0,
    class: "sidebar-section sidebar-nav"
};
const _hoisted_4 = { class: "section-content" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
    key: 1,
    class: "sidebar-section sidebar-page"
};
const _hoisted_7 = { class: "section-content" };
const _hoisted_8 = ["onClick"];
const _hoisted_9 = { class: "chat-item-content" };
const _hoisted_10 = { class: "item-title" };
const _hoisted_11 = {
    key: 0,
    class: "item-subtitle"
};
const _hoisted_12 = {
    key: 1,
    class: "item-progress"
};
const _hoisted_13 = { class: "progress-bar" };
const _hoisted_14 = {
    key: 2,
    class: "item-meta"
};
const _hoisted_15 = {
    key: 3,
    class: "item-meta"
};
const _hoisted_16 = {
    key: 1,
    class: "sidebar-empty"
};
const _hoisted_17 = {
    key: 2,
    class: "sidebar-spacer"
};
const _hoisted_18 = { class: "sidebar-footer" };
const _hoisted_19 = { class: "account-avatar" };
const _hoisted_20 = { class: "account-info" };
const _hoisted_21 = { class: "account-name" };
import { ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import MGDialog from '@/components/elements/MGDialog.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'DesktopSidebar',
    props: {
        open: { type: Boolean, default: false },
        collapsed: { type: Boolean, default: false },
        colourMode: { default: 'dark' },
        safeTop: { default: 0 },
        userName: { default: 'User' },
        navItems: { default: () => [] },
        pageItems: { default: () => [] },
        pageItemsTitle: { default: 'Recents' },
        pageItemsEmptyText: { default: '' },
        currentPageItemId: { default: null },
        actionButton: { default: null }
    },
    emits: ["action-click", "page-item-click", "page-item-delete", "page-item-rename", "close", "logout", "open-settings", "toggle-collapse"],
    setup(__props, { emit: __emit }) {
        const router = useRouter();
        const route = useRoute();
        const props = __props;
        const emit = __emit;
        const showRenameDialog = ref(false);
        const renameValue = ref('');
        const renamingChatId = ref(null);
        const navCollapsed = ref(false);
        const pageCollapsed = ref(false);
        const userInitial = computed(() => {
            return props.userName ? props.userName.charAt(0).toUpperCase() : 'U';
        });
        function openRenameDialog(chat) {
            renamingChatId.value = chat.id;
            renameValue.value = chat.title;
            showRenameDialog.value = true;
        }
        function confirmRename() {
            if (renameValue.value.trim()) {
                emit('page-item-rename', { id: renamingChatId.value, title: renameValue.value.trim() });
            }
            showRenameDialog.value = false;
        }
        function openSettings() {
            emit('open-settings');
        }
        function navigateTo(navRoute) {
            emit('close');
            router.push(navRoute);
        }
        function isActiveRoute(navRoute) {
            const currentPath = route.path;
            if (navRoute === '/desktop') {
                return currentPath === '/desktop' || currentPath === '/desktop/';
            }
            return currentPath.startsWith(navRoute);
        }
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_list_item_title = _resolveComponent("v-list-item-title");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list = _resolveComponent("v-list");
            const _component_v_menu = _resolveComponent("v-menu");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_btn = _resolveComponent("v-btn");
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", {
                    class: _normalizeClass(["sidebar", [_ctx.colourMode, { open: _ctx.open, collapsed: _ctx.collapsed }]]),
                    style: _normalizeStyle({ top: _ctx.safeTop + 'px' })
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("img", {
                            src: require('@/assets/mg.png'),
                            alt: "MG",
                            class: "sidebar-logo"
                        }, null, 8, _hoisted_2),
                        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "sidebar-title" }, "Money Guided", -1)),
                        _createElementVNode("button", {
                            class: "collapse-btn",
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('toggle-collapse')))
                        }, [
                            _createVNode(_component_v_icon, { size: "18" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.collapsed ? 'mdi-chevron-right' : 'mdi-chevron-left'), 1)
                                ]),
                                _: 1
                            })
                        ])
                    ]),
                    (_ctx.navItems.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("button", {
                                class: "sidebar-section-title",
                                onClick: _cache[1] || (_cache[1] = ($event) => (navCollapsed.value = !navCollapsed.value))
                            }, [
                                _cache[11] || (_cache[11] = _createElementVNode("span", null, "Navigate", -1)),
                                _createVNode(_component_v_icon, { size: "14" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(navCollapsed.value ? 'mdi-chevron-down' : 'mdi-chevron-up'), 1)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _createVNode(_Transition, { name: "section-collapse" }, {
                                default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("div", _hoisted_4, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                                key: item.route,
                                                class: _normalizeClass(["sidebar-item", { active: isActiveRoute(item.route) }]),
                                                onClick: ($event) => (navigateTo(item.route))
                                            }, [
                                                _createVNode(_component_v_icon, { size: "20" }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.icon), 1)
                                                    ]),
                                                    _: 2
                                                }, 1024),
                                                _createElementVNode("span", null, _toDisplayString(item.label), 1)
                                            ], 10, _hoisted_5));
                                        }), 128))
                                    ], 512), [
                                        [_vShow, !navCollapsed.value]
                                    ])
                                ]),
                                _: 1
                            })
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.pageItemsTitle || _ctx.actionButton || _ctx.pageItems.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            (_ctx.pageItemsTitle)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "sidebar-section-title",
                                    onClick: _cache[2] || (_cache[2] = ($event) => (pageCollapsed.value = !pageCollapsed.value))
                                }, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.pageItemsTitle), 1),
                                    _createVNode(_component_v_icon, { size: "14" }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(pageCollapsed.value ? 'mdi-chevron-down' : 'mdi-chevron-up'), 1)
                                        ]),
                                        _: 1
                                    })
                                ]))
                                : _createCommentVNode("", true),
                            _createVNode(_Transition, { name: "section-collapse" }, {
                                default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("div", _hoisted_7, [
                                        (_ctx.actionButton)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "sidebar-item new-chat",
                                                onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.$emit('action-click')))
                                            }, [
                                                _createVNode(_component_v_icon, { size: "20" }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.actionButton.icon), 1)
                                                    ]),
                                                    _: 1
                                                }),
                                                _createElementVNode("span", null, _toDisplayString(_ctx.actionButton.label), 1)
                                            ]))
                                            : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageItems, (item) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: item.id,
                                                class: _normalizeClass(["chat-item-wrapper", { 'active': item.id === _ctx.currentPageItemId, 'rich-item': item.subtitle, 'divider-item': item.isDivider }]),
                                                onClick: ($event) => (!item.isDivider && _ctx.$emit('page-item-click', item.id))
                                            }, [
                                                _createElementVNode("div", _hoisted_9, [
                                                    _createElementVNode("div", _hoisted_10, _toDisplayString(item.title), 1),
                                                    (item.subtitle)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(item.subtitle), 1))
                                                        : _createCommentVNode("", true),
                                                    (item.progress !== undefined)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                            _createElementVNode("div", _hoisted_13, [
                                                                _createElementVNode("div", {
                                                                    class: "progress-fill",
                                                                    style: _normalizeStyle({ width: item.progress + '%', background: item.colour })
                                                                }, null, 4)
                                                            ]),
                                                            _createElementVNode("span", {
                                                                class: "progress-text",
                                                                style: _normalizeStyle({ color: item.colour })
                                                            }, _toDisplayString(item.progress) + "%", 5)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (item.meta)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                            _createElementVNode("span", null, _toDisplayString(item.meta), 1),
                                                            (item.statusChip && !item.meta2)
                                                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                                                    key: 0,
                                                                    size: "x-small",
                                                                    color: item.statusChip.color,
                                                                    "prepend-icon": item.statusChip.icon,
                                                                    variant: item.statusChip.variant || 'flat'
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(item.statusChip.label), 1)
                                                                    ]),
                                                                    _: 2
                                                                }, 1032, ["color", "prepend-icon", "variant"]))
                                                                : _createCommentVNode("", true)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (item.meta2)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                                            _createElementVNode("span", null, _toDisplayString(item.meta2), 1),
                                                            (item.statusChip)
                                                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                                                    key: 0,
                                                                    size: "x-small",
                                                                    color: item.statusChip.color,
                                                                    "prepend-icon": item.statusChip.icon,
                                                                    variant: item.statusChip.variant || 'flat'
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(item.statusChip.label), 1)
                                                                    ]),
                                                                    _: 2
                                                                }, 1032, ["color", "prepend-icon", "variant"]))
                                                                : _createCommentVNode("", true)
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                (!item.subtitle)
                                                    ? (_openBlock(), _createBlock(_component_v_menu, {
                                                        key: 0,
                                                        location: "bottom end"
                                                    }, {
                                                        activator: _withCtx(({ props }) => [
                                                            _createElementVNode("button", _mergeProps({
                                                                class: "chat-menu-btn",
                                                                ref_for: true
                                                            }, props, {
                                                                onClick: _cache[4] || (_cache[4] = _withModifiers(() => { }, ["stop"]))
                                                            }), [
                                                                _createVNode(_component_v_icon, { size: "16" }, {
                                                                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                                                                        _createTextVNode("mdi-dots-horizontal")
                                                                    ])),
                                                                    _: 1
                                                                })
                                                            ], 16)
                                                        ]),
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_list, { class: "chat-menu-list" }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_v_list_item, {
                                                                        onClick: ($event) => (openRenameDialog(item))
                                                                    }, {
                                                                        prepend: _withCtx(() => [
                                                                            _createVNode(_component_v_icon, { size: "18" }, {
                                                                                default: _withCtx(() => _cache[13] || (_cache[13] = [
                                                                                    _createTextVNode("mdi-pencil-outline")
                                                                                ])),
                                                                                _: 1
                                                                            })
                                                                        ]),
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_component_v_list_item_title, null, {
                                                                                default: _withCtx(() => _cache[14] || (_cache[14] = [
                                                                                    _createTextVNode("Rename")
                                                                                ])),
                                                                                _: 1
                                                                            })
                                                                        ]),
                                                                        _: 2
                                                                    }, 1032, ["onClick"]),
                                                                    _createVNode(_component_v_list_item, {
                                                                        onClick: ($event) => (_ctx.$emit('page-item-delete', item.id)),
                                                                        class: "delete-item"
                                                                    }, {
                                                                        prepend: _withCtx(() => [
                                                                            _createVNode(_component_v_icon, {
                                                                                size: "18",
                                                                                color: "#e57373"
                                                                            }, {
                                                                                default: _withCtx(() => _cache[15] || (_cache[15] = [
                                                                                    _createTextVNode("mdi-delete-outline")
                                                                                ])),
                                                                                _: 1
                                                                            })
                                                                        ]),
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_component_v_list_item_title, { class: "delete-text" }, {
                                                                                default: _withCtx(() => _cache[16] || (_cache[16] = [
                                                                                    _createTextVNode("Delete")
                                                                                ])),
                                                                                _: 1
                                                                            })
                                                                        ]),
                                                                        _: 2
                                                                    }, 1032, ["onClick"])
                                                                ]),
                                                                _: 2
                                                            }, 1024)
                                                        ]),
                                                        _: 2
                                                    }, 1024))
                                                    : _createCommentVNode("", true)
                                            ], 10, _hoisted_8));
                                        }), 128)),
                                        (_ctx.pageItems.length === 0 && _ctx.pageItemsEmptyText)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.pageItemsEmptyText), 1))
                                            : _createCommentVNode("", true)
                                    ], 512), [
                                        [_vShow, !pageCollapsed.value]
                                    ])
                                ]),
                                _: 1
                            })
                        ]))
                        : _createCommentVNode("", true),
                    (!_ctx.pageItemsTitle && !_ctx.actionButton && !_ctx.pageItems.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_v_menu, {
                            location: "top start",
                            offset: [0, 8]
                        }, {
                            activator: _withCtx(({ props }) => [
                                _createElementVNode("button", _mergeProps({ class: "account-btn" }, props), [
                                    _createElementVNode("div", _hoisted_19, _toDisplayString(userInitial.value), 1),
                                    _createElementVNode("div", _hoisted_20, [
                                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.userName), 1)
                                    ]),
                                    _createVNode(_component_v_icon, {
                                        size: "16",
                                        class: "account-chevron"
                                    }, {
                                        default: _withCtx(() => _cache[17] || (_cache[17] = [
                                            _createTextVNode("mdi-chevron-up")
                                        ])),
                                        _: 1
                                    })
                                ], 16)
                            ]),
                            default: _withCtx(() => [
                                _createVNode(_component_v_list, { class: "account-menu-list" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_list_item, { onClick: openSettings }, {
                                            prepend: _withCtx(() => [
                                                _createVNode(_component_v_icon, { size: "20" }, {
                                                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                                                        _createTextVNode("mdi-cog-outline")
                                                    ])),
                                                    _: 1
                                                })
                                            ]),
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                    default: _withCtx(() => _cache[19] || (_cache[19] = [
                                                        _createTextVNode("Settings")
                                                    ])),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_v_list_item, {
                                            onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.$emit('logout'))),
                                            class: "logout-item"
                                        }, {
                                            prepend: _withCtx(() => [
                                                _createVNode(_component_v_icon, { size: "20" }, {
                                                    default: _withCtx(() => _cache[20] || (_cache[20] = [
                                                        _createTextVNode("mdi-logout")
                                                    ])),
                                                    _: 1
                                                })
                                            ]),
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                    default: _withCtx(() => _cache[21] || (_cache[21] = [
                                                        _createTextVNode("Log out")
                                                    ])),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ])
                ], 6),
                _createElementVNode("div", {
                    class: _normalizeClass(["sidebar-overlay", { 'open': _ctx.open }]),
                    onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.$emit('close')))
                }, null, 2),
                _createVNode(MGDialog, {
                    modelValue: showRenameDialog.value,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((showRenameDialog).value = $event)),
                    title: "Rename Chat",
                    maxWidth: "400px",
                    contentHeight: "auto"
                }, {
                    content: _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                            modelValue: renameValue.value,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((renameValue).value = $event)),
                            label: "Chat name",
                            variant: "outlined",
                            density: "comfortable",
                            "hide-details": "",
                            onKeyup: _withKeys(confirmRename, ["enter"])
                        }, null, 8, ["modelValue"])
                    ]),
                    actions: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                            class: "rename-btn",
                            block: "",
                            onClick: confirmRename
                        }, {
                            default: _withCtx(() => _cache[22] || (_cache[22] = [
                                _createTextVNode("Rename")
                            ])),
                            _: 1
                        }),
                        _createVNode(_component_v_btn, {
                            class: "cancel-btn",
                            variant: "text",
                            block: "",
                            onClick: _cache[8] || (_cache[8] = ($event) => (showRenameDialog.value = false))
                        }, {
                            default: _withCtx(() => _cache[23] || (_cache[23] = [
                                _createTextVNode("Cancel")
                            ])),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
